import EzController from 'controllers/ez-base-controller';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import {
  REACTIVATION_BANNER_TRIGGERED,
  REACTIVATION_BANNER_COMPLETE,
} from 'components/analytics/conversions/constants/actions';

export default class ReactivationBannerController extends EzController {
  connect() {
    sendTrackingEvent({
      element: this.element as HTMLElement,
      data: {
        action: REACTIVATION_BANNER_TRIGGERED,
        non_interaction: true,
      },
    });
  }

  trackComplete = (event) => {
    sendTrackingEvent({
      element: event.currentTarget,
      data: {
        action: REACTIVATION_BANNER_COMPLETE,
      },
    });
  }
}
